<app-header-one></app-header-one>

<section class="listing-categories-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2><span class="initiatives-text">Hospitals</span></h2>
        </div>
      

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let hospital of hospitals">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a>
                            <img
                                [src]="hospital.imageUri"
                                alt="image"
                            />
                        </a>
                        <div class="date">
                            <span>{{hospital.start_time}}</span>
                        </div>
                    </div>

                    <div class="post-content text-center">
                        <span class="category"
                            >{{hospital.name}}</span
                        >
                      
                        <a  class="details-btn"
                            >Read More</a
                        >
                    </div>
                </div>
            </div>

           
        </div>
    </div>
</section>
